import React from 'react'

import {
    Table,
    OverlayTrigger,
} from 'react-bootstrap'

// icons
import FeatherIcon from 'feather-icons-react';

// loading
import TableLodingSkeleton from './table__loadingSkeleton'

// react router
import { Link } from 'react-router-dom'

import { renderTooltipEdit, renderTooltipDelete } from '../tooltips/SectionTable__Tooltips'

import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

// when no image
import noImgFound from 'assets/images/no-img-found.png'

export default function MainTable(props) {
    // props
    const {
        tableColumnsVisibility,

        allCheckboxSelected,
        handleSelectAllChange,

        loading,
        loadingCount,
        tableData,

        handleDelete
    } = props

    // store url
    const [storeUrl] = useStoreUrl()

    return (
        <Table responsive className="mb-0">
            <thead>
                <tr>
                    <th width={80}>
                        <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                            <input
                                type="checkbox"
                                className="d-none"
                                checked={allCheckboxSelected}
                                onChange={handleSelectAllChange}
                            />
                            <span className="box d-flex align-items-center justify-content-center border" style={{ height: 17, width: 17 }}>
                                <FeatherIcon
                                    icon="check"
                                    size="11"
                                    className="icon position-relative" />
                            </span>
                        </label>
                    </th>

                    {
                        tableColumnsVisibility.find(item => item.columnName === `column_${"image"}`)?.visible && (
                            <th width="150">
                                <p className="text-capitalize">
                                    Image
                                </p>
                            </th>
                        )
                    }

                    {
                        tableColumnsVisibility.find(item => item.columnName === `column_${"link"}`)?.visible && (
                            <th>
                                <p className="text-capitalize">
                                    Link
                                </p>
                            </th>
                        )
                    }

                    {
                        tableColumnsVisibility.find(item => item.columnName === `column_${"caption"}`)?.visible && (
                            <th>
                                <p className="text-capitalize">
                                    Caption
                                </p>
                            </th>
                        )
                    }

                    <th width="60"></th>
                </tr>
            </thead>

            <tbody>
                {
                    loading ? (
                        <React.Fragment>
                            {
                                loadingCount?.length && loadingCount.map(item => (
                                    <React.Fragment key={item}>
                                        <TableLodingSkeleton />
                                    </React.Fragment>
                                ))
                            }
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            {
                                tableData?.length ? tableData.map(item => {
                                    return (
                                        <tr key={item.slider_id}>
                                            <td className="column__checkbox">
                                                <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                                    <input
                                                        type="checkbox"
                                                        className="d-none"
                                                    />
                                                    <span className="box d-flex align-items-center justify-content-center border" style={{ height: 17, width: 17 }}>
                                                        <FeatherIcon
                                                            icon="check"
                                                            size="11"
                                                            className="icon position-relative" />
                                                    </span>
                                                </label>
                                            </td>

                                            {
                                                tableColumnsVisibility.find(item => item.columnName === `column_${"image"}`)?.visible && (
                                                    <td className="column__img">
                                                        <div className="img">
                                                            <img 
                                                                src={item.image || noImgFound} 
                                                                alt="slider-img" 
                                                                className="img-fluid"
                                                                height={50} 
                                                                width={50}
                                                            />
                                                        </div>
                                                    </td>
                                                )
                                            }

                                            {
                                                tableColumnsVisibility.find(item => item.columnName === `column_${"link"}`)?.visible && (
                                                    <td className="column__link">
                                                        <p className="">{ item.link }</p>
                                                    </td>
                                                )
                                            }

                                            {
                                                tableColumnsVisibility.find(item => item.columnName === `column_${"caption"}`)?.visible && (
                                                    <td className="column__caption">
                                                        <p className="">{ item.caption }</p>
                                                    </td>
                                                )
                                            }

                                            <td className="column__actions">
                                                <div className="d-flex justify-content-end">
                                                    <OverlayTrigger
                                                        placement={"left"}
                                                        overlay={renderTooltipEdit}
                                                    >
                                                        <Link
                                                            to={{
                                                                pathname: storeUrl + '/catalog/sliders/edit/' + item.slider_id,
                                                            }}
                                                            className="st-round-btn st-btn-transparent st-btn-xs d-flex align-items-center justify-content-center me-1"
                                                        >
                                                            <FeatherIcon
                                                                icon="edit-2"
                                                                size="15"
                                                                className="icon" />
                                                        </Link>
                                                    </OverlayTrigger>

                                                    <OverlayTrigger
                                                        placement={"left"}
                                                        overlay={renderTooltipDelete}
                                                    >
                                                        <button
                                                            className="st-round-btn st-btn-transparent st-btn-xs d-flex align-items-center justify-content-center"
                                                            onClick={ev => handleDelete(ev, item.slider_id)}
                                                        >
                                                            <FeatherIcon
                                                                icon="trash"
                                                                size="15"
                                                                className="icon" />
                                                        </button>
                                                    </OverlayTrigger>
                                                </div>
                                            </td>

                                        </tr>
                                    )
                                }) : (
                                    !loading ? (
                                        <tr>
                                            <td colSpan="11">
                                                <p className="no-data-found text-center st-fw-700 py-1">
                                                    no data found
                                                </p>
                                            </td>
                                        </tr>
                                    ) : null
                                )
                            }
                        </React.Fragment>
                    )
                }
            </tbody>
        </Table>
    )
}
